import React, { useState, useEffect, Fragment, useMemo } from 'react'
import { useHistory } from 'react-router';
import { valdiatePage } from '../../global';
import { invoicesummaryreport } from '../../services/reportservice';
import Loader from '../../images/whiteloader.svg';
import { getLocations, getMultipleSubAccountLocations } from '../../services/userservice';
import { setLoading } from '../../redux/appSlice';
import { useDispatch, useSelector } from 'react-redux';
import ExportExcelButton from "../../components/exportExcelButton";
import Pagination from '../../components/paginations';

export const invoiceSummaryColumns = [
    { label: "Invoice Number", key: "invoiceNumber" },
    { label: "No of Shipments", key: "CNCount" },
    { label: "Invoice Date", key: "InvoiceDate" },
    { label: "Courier Charges", key: "CourierCharges" },
    { label: "OSA/NSA Charges", key: "OSANSACharges" },
    { label: "Fuel Charges", key: "FuelCharges" },
    { label: "GST on OSA/NSA", key: "GSTonOSANSA" },
    { label: "Other GST", key: "OtherGST" },
    { label: "Courier GST", key: "CourierGst" },
    { label: "Total GST", key: "TotalGst" },
    { label: "Total Without GST", key: "TotalWithoutGST" },
    { label: "Total Amount", key: "TotalAmount" },
    { label: "Invoice Amount", key: "InvAmount" },
  ];

const InvoiceSummary = () => {

    const dispatch = useDispatch();
    const { accounts, loading, userInfo, subaccounts } = useSelector(state => state.appData);

    const now = new Date();
    const today = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;

    const history = useHistory();

    const d = {
        StartDate: today,
        EndDate: today,
        locationID: [],
        account: accounts.length > 1 ? [accounts[0]] : '',
        creditclientid: [],
        subAccountId:  []
    };
    const [data, setData] = useState(d);
    const [grid, setGrid] = useState([]);
    const [locations, setLocations] = useState([]);
    const [subAccountsLocal, setSubAccountsLocal] = useState([]);

    const [page, setPage] = useState(0);
    const [pageLimit, setPageLimit] = useState(50);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [originalGrid, setOriginalGrid] = useState([]);
    
    const searchObjInit = {
        invoiceNumber: '',
        TotalAmount: '',
        InvAmount: ''
    };

    const [searchObject, setSearchObj] = useState(searchObjInit);
    const updateSearchData = (key, val) => setSearchObj(prev => { return { ...prev, [key]: val } });
    
    const gridKeys = [
        {key: 'invoiceNumber', name: 'Invoice Number', searchBox: true, visible: true},
        {key: 'CNCount', name: 'No of Shipments', searchBox: false, visible: true},
        {key: 'InvoiceDate', name: 'Invoice Date', searchBox: false, visible: true},
        {key: 'CourierCharges', name: 'Courier Charges', searchBox: false, visible: true},
        {key: 'OSANSACharges', name: 'OSA/NSA Charges', searchBox: false, visible: true},
        {key: 'FuelCharges', name: 'Fuel Charges', searchBox: false, visible: true},
        {key: 'GSTonOSANSA', name: 'GST on OSA/NSA', searchBox: false, visible: true},
        {key: 'OtherGST', name: 'Other GST', searchBox: false, visible: true},
        {key: 'CourierGst', name: 'Courier GST', searchBox: false, visible: true},
        {key: 'TotalGst', name: 'Total GST', searchBox: false, visible: true},
        {key: 'TotalWithoutGST', name: 'Total Without GST', searchBox: false, visible: true},
        {key: 'TotalAmount', name: 'Total Amount', searchBox: true, visible: true},
        {key: 'InvAmount', name: 'Invoice Amount', searchBox: true, visible: true}
    ]
    
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
          direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    let filterData = useMemo(() => {
        return grid.filter((item, index) => {
            return (index >= page * pageLimit) & (index < (page + 1) * pageLimit);
        })
    }, [page, grid, pageLimit, grid.length]);

    const sortedArray = [...filterData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });

    // useEffect(() => {
    //     if (!valdiatePage('/invoicesummary')) {
    //         history.push('/login');
    //     }

    //     if (data.account) {
    //         getLocations(userInfo.id, data.account).then(locs => {
    //             if (locs) {
    //                 setLocations(locs);
    //                 setData({ ...data, account: data.account, locationID: locs.map(v => v.value).join(), creditclientid: locs.map(v => v.creditClientId).join() });
    //             }
    //         })
    //     }
    // }, []);

    useEffect(async () => {
        
        if (!valdiatePage('/invoicesummary')) {
            history.push('/login');
        }

        if (accounts.length > 0) {

            const subAccs = subaccounts.filter(e => e.accountNo.toUpperCase() === accounts[0].toUpperCase())

            setSubAccountsLocal(subAccs);

            const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: [subAccs[0].id]})
            const d = { ...data, account: [accounts[0]], subAccountId: [subAccs[0].id]};

            console.log(locs);
            if (locs.length > 0) {
                d.locationID = [+locs[0].value] 
                d.creditclientid = [+locs[0].creditClientId] 
                setLocations(locs);
            }
            setData(d);
        }
    }, [])

    const updateData = (key, val) => setData(prev => { return { ...prev, [key]: val } });

    const onSearch = async () => {

        if (!data.StartDate) {
            alert('Select Start Date');
            return;
        }
        if (!data.EndDate) {
            alert('Select End Date');
            return;
        }

        if (!data.account) {
            alert('Select Account');
            return;
        }
        if (!data.locationID || data.locationID.length == 0) {
            alert('Select Location');
            return;
        }

        // if (data.locationID == "") {
        //     let locsall = "";
        //     for (var i in locations) {
        //         locsall += "'" + locations[i].value + "',";
        //     }
        //     locsall = locsall.replace(/,\s*$/, "");
        //     data.locationID = locsall;
        // }
        // if (data.creditclientid == "") {
        //     let credall = "";
        //     for (var i in locations) {
        //         credall += "'" + locations[i].creditClientId + "',";
        //     }
        //     credall = credall.replace(/,\s*$/, "");
        //     data.creditclientid = credall;
        // }

        const payload = {
            "StartDate": data.StartDate,
            "EndDate": data.EndDate,
            "locationID": data.locationID.join(),
            "account": data.account.join(),
            "creditclientid": data.creditclientid.join()
        }

        dispatch(setLoading({ data: true }));

        var rs = await invoicesummaryreport(payload);

        dispatch(setLoading({ data: false }));
        if (rs.sts == 0) {
            if (rs.data.length > 0) {
                setOriginalGrid(rs.data);
                setGrid(rs.data);
            }
            else {
                alert('No Data Found');
                setGrid([]);
            }
        }
        else {
            alert(rs.msg);
            setGrid([]);
        }
    }


    return userInfo && <section className="section">
        <div className="section-header">
            <h1>Invoice Summary Report</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>

            <div className="row pb-2">
                <div className="col">
                    <label>Account</label>
                    <select className="form-select" multiple value={data.account} onChange={async (e) => {
                        let value = Array.from(e.target.selectedOptions, option => option.value);
                        let d = { ...data, account: value };
                        if (value && value.length > 0) {
                            const subAccs = subaccounts.filter(e => value.includes(e.accountNo));
                            setSubAccountsLocal(subAccs);
                            const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: [subAccs[0].id]})
                            d.subAccountId =  [subAccs[0].id];
                
                            if (locs.length > 0) {
                                d.locationID = [+locs[0].value]
                                setLocations(locs);
                            } else {
                                setLocations([]);
                            }
                        } else {
                            setLocations([]);
                        }
                        setData(d);
                    }}>
                        {
                            accounts.map((x, index) => <option key={index} value={x}>{x}</option>)
                        }
                    </select>
                </div>

                <div className="col-lg">
                    <label>Sub Account</label>
                    <select className="form-select" value={data.subAccountId} multiple onChange={async (e) => {
                        const selectedOptions = Array.from(e.target.selectedOptions);

                        const accnos = selectedOptions
                            .map(option => option.getAttribute('data-accno'))
                            .filter(acc => acc && acc.trim() !== '');
                
                        const uniqueAccnos = Array.from(
                            new Map(accnos.map(acc => [acc.toLowerCase(), acc])).values()
                        );

                        const val = Array.from(new Set(
                            selectedOptions
                                .map(option => option.value)
                                .filter(v => v && !isNaN(v))
                                .map(v => parseInt(v))
                        ));


                        console.log("Filtered SubAccount IDs:", val);
                        console.log("Unique Account Nos (data-accno):", uniqueAccnos);

                        const d = { ...data, subAccountId: val, account: uniqueAccnos };
                        if (val) {
                            //d.isCod = e.target[e.target.selectedIndex].getAttribute('data-iscod') === 'true';
                            const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: val})
                            console.log(locs);
                            if (locs && locs.length > 0) {
                                
                                d.locationID = [+locs[0].value]
                                setLocations(locs);
                            } else {
                                setLocations([]);
                            }
                        } else {
                            setLocations([]);
                            //d.isCod = null;
                        }
                        setData({ ...d});
                    }}>
                        {/* <option value="" data-accno="" data-iscod="">Select Sub Account</option> */}
                        {
                            subAccountsLocal.map((x, index) => <option key={index} value={x.id} data-iscod={x.isCod} data-accno={x.accountNo}>{x.name}</option>)
                        }
                    </select>
                </div>

                <div className="col">
                    <label>Location</label>
                    <select className="form-select" multiple value={data.locationID} onChange={async (e) => {
                        //let val = Array.from(e.target.selectedOptions, option => +option.value);
                        const selectedOptions = Array.from(e.target.selectedOptions);
        
                        const val = selectedOptions.map(option => +option.value); // locationID as numbers
                
                        const creditClientIds = selectedOptions.map(option => option.getAttribute('data-creditclientid')); // creditclientid as strings

                        console.log(creditClientIds);
                        setData({ ...data, locationID: val, creditclientid : creditClientIds });
                    }}>
                        {
                            locations.length > 0 && locations.map((x, index) => <option key={index} data-creditclientid={x.creditClientId} value={x.value}>{x.text}</option>)
                        }
                    </select>
                </div>
            </div>

            <div className="row pb-2">
                {/* <div className="col">
                    <label>Account</label>

                    <select className="form-select" value={data.account} onChange={async (e) => {
                        const val = e.target.value;
                        setData({ ...data, account: val });
                        if (val) {
                            const locs = await getLocations(userInfo.id, val)
                            if (locs)
                                setLocations(locs);
                        } else {
                            setLocations([]);
                        }
                    }}>
                        <option value={(accounts.length > 1 ? accounts.join() : '')}>Select All Accounts</option>
                        {
                            accounts.map((x, index) => <option key={index} value={x}>{x}</option>)
                        }
                    </select>
                </div>
                <div className="col">
                    <label>Location</label>
                    <select className="form-select" value={data.locationID} onChange={async (e) => {
                        const val = e.target.value;
                        const creditclientid = e.target[e.target.selectedIndex].getAttribute('data-creditclientid');
                        setData({ ...data, account: data.account, locationID: val, creditclientid: creditclientid });
                    }}>
                        {locations.length > 0 && <option value={locations.map(v => v.value).join()} data-creditclientid={locations.map(v => v.creditClientId).join()}>Select All Location</option>}
                        {
                            locations.map((x, index) => <option key={index} data-creditclientid={x.creditClientId} value={x.value}>{x.text}</option>)
                        }
                    </select>
                </div> */}

                <div className="col">
                    <label>Start Date</label>
                    <input type="date" className="form-control" value={data.StartDate} onChange={(e) => updateData('StartDate', e.target.value)} />
                </div>
                <div className="col">
                    <label>End Date</label>
                    <input type="date" className="form-control" value={data.EndDate} onChange={(e) => updateData('EndDate', e.target.value)} />
                </div>

                <div className="col">
                    <button type="button" className="btn btn-primary" disabled={loading} style={{ marginTop: '1.3rem' }} onClick={onSearch}>
                        {loading ? <img src={Loader} height="30" /> : 'Search'}
                    </button>
                </div>
            </div>
            {
                originalGrid && originalGrid.length > 0 &&
                <div className="row mt-3 pb-2">
                    <div className="col-12">
                        <div style={{ textAlign: 'right' }}>
                            {/* <ExportExcelInvoiceSummary data={originalGrid} /> */}
                               <ExportExcelButton data={originalGrid} columns={invoiceSummaryColumns} fileName="InvoiceSummaryReport"
                                />
                        </div>
                        <br />

                        <Pagination
                            setGrid={setGrid}
                            searchObjInit={searchObjInit}
                            searchObject={searchObject}
                            originalGrid={originalGrid}
                            setPage={setPage}
                            setPageLimit={setPageLimit}
                            requestSort={requestSort}
                            sortConfig={sortConfig}
                            updateSearchData={updateSearchData}
                            sortedArray={sortedArray}
                            data={data}
                            dataCount={grid.length}
                            pageLimit={pageLimit}  
                            gridKeys={gridKeys}
                            page={page}
                            grid={
                                sortedArray && sortedArray.length > 0 && sortedArray.map((x, index) =>
                                    <Fragment key={index}>
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{x.invoiceNumber}</td>
                                            <td>{x.CNCount}</td>
                                            <td>{x.InvoiceDate}</td>
                                            <td>{x.CourierCharges.toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                            <td>{x.OSANSACharges.toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                            <td>{x.FuelCharges.toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                            <td>{x.GSTonOSANSA.toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                            <td>{x.OtherGST.toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                            <td>{x.CourierGst.toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                            <td>{x.TotalGst.toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                            <td>{x.TotalWithoutGST.toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                            <td>{x.TotalAmount.toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                            <td>{x.InvAmount.toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                        </tr>
                                    </Fragment>
                                )
                            }
                        />
                    </div>
                </div>
            }
        </div>
    </section>
}

export default InvoiceSummary;